import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/footer/FooterClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/shared/HotdeskButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
